import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DeviceTypeService } from '@services/device-type.service';

@Component({
  selector: 'app-search-bar',
  templateUrl: './app-search-bar.component.html',
  styleUrls: ['./app-search-bar.component.scss'],
  standalone: false,
})
export class SearchBarComponent implements OnInit {
  public searchForm: FormGroup;

  @Input() query: string = '';
  @Input() isSearchHome = false;
  @Output() onSearch = new EventEmitter<string>();

  public isIOS = false;

  constructor(
    public translateService: TranslateService,
    private readonly fb: FormBuilder,
    public deviceType: DeviceTypeService,
  ) {
    this.searchForm = this.fb.group({
      query: [''],
    });
    this.searchForm.get('query')?.setValue(this.query);
  }

  ngOnInit(): void {
    this.searchForm.get('query')?.setValue(this.query);
    this.isIOS = this.deviceType.isIOS;
  }

  search(query = ''): void {
    if (query) this.searchForm.get('query')?.setValue(query);
    this.query = this.searchForm.get('query')?.value;
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement && activeElement.blur) {
      activeElement.blur();
    }
    this.onSearch.emit(this.query);
  }

  resetQuery(event: Event): void {
    if ((event as any).pointerType != '' || this.isIOS) {
      this.searchForm.get('query')?.setValue('');
      this.query = this.searchForm.value.query;
      const searchInput = document.getElementById('searchInput');
      if (searchInput) {
        searchInput.focus();
        searchInput.classList.remove('med_expanded_header_search');
        searchInput.classList.remove('med_expanded_home_search');
        searchInput.style.height = '100%';
      }
    }
  }

  onKeyup(event: any): void {
    this.adjustInputHeight(event);
  }

  adjustInputHeight(event: any, once?: boolean): void {
    const textarea = event.target as HTMLTextAreaElement;

    setTimeout(() => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';

      const inputHeight = textarea.getBoundingClientRect().height;

      if (event.type === 'paste' && !once) {
        this.adjustInputHeight(event, true);
        return;
      }

      if (inputHeight > 55) {
        this.isSearchHome
          ? textarea.classList.add('med_expanded_home_search')
          : textarea.classList.add('med_expanded_header_search');
      } else {
        textarea.classList.remove('expanded');
      }
    }, 100);
  }
}
